import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './StreetScene.css';
import { SIGNING_DAY } from '../config/signingDay';

const API = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api`;
const V = '3'; // bump to bust cached asset 404s
const pad = (n) => String(n).padStart(2, '0');

function useCountdown() {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);
    const ms = Math.max(0, SIGNING_DAY.getTime() - now);
    const s = Math.floor(ms / 1000);
    return {
        live: SIGNING_DAY.getTime() - now <= 0,
        days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600),
        mins: Math.floor((s % 3600) / 60), secs: s % 60,
    };
}

// The TrapWorld flyer is printed into the footage. The poster still is painted as the
// frame background (so it's never blank), and the video fades in on top once it plays.
export default function StreetScene() {
    const [spots, setSpots] = useState(null);
    const [playing, setPlaying] = useState(false);
    const cd = useCountdown();

    useEffect(() => {
        axios.get(`${API}/stats`).then((r) => setSpots(r.data?.total_artists ?? null)).catch(() => {});
    }, []);

    const scrollDown = () => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });

    return (
        <div className="ss-stage">
            <div className="ss-frame" style={{ backgroundImage: `url(/street-poster.jpg?v=${V})` }}>
                <video className={`ss-bg ${playing ? 'playing' : ''}`} autoPlay muted loop playsInline
                    preload="auto" aria-hidden="true" onPlaying={() => setPlaying(true)}>
                    <source src={`/street.mp4?v=${V}`} type="video/mp4" />
                </video>
            </div>

            <div className="ss-vignette" />

            <div className="ss-hud">
                <div className="k">Signing Day in</div>
                {cd.live ? (
                    <div className="cell"><b>SIGNING DAY IS LIVE</b></div>
                ) : (
                    <div className="clock">
                        <div className="cell"><b>{pad(cd.days)}</b><i>Days</i></div>
                        <span className="colon">:</span>
                        <div className="cell"><b>{pad(cd.hours)}</b><i>Hrs</i></div>
                        <span className="colon">:</span>
                        <div className="cell"><b>{pad(cd.mins)}</b><i>Min</i></div>
                        <span className="colon">:</span>
                        <div className="cell"><b>{pad(cd.secs)}</b><i>Sec</i></div>
                    </div>
                )}
            </div>

            <div className="ss-cta">
                <Link to="/register" className="ss-claim">CLAIM YOUR SPOT — FREE</Link>
                <div className="ss-spots"><b>{spots == null ? '—' : spots}</b> spots claimed · all costs included</div>
            </div>

            <button className="ss-scroll" onClick={scrollDown} aria-label="Scroll for details">
                <span>Scroll for details</span>
                <span className="arrow">↓</span>
            </button>
        </div>
    );
}
